// Frontend/src/auth/authConfig.js
import { LogLevel } from "@azure/msal-browser";

// Browser check variables for compatibility
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

// Get Azure AD configuration from environment
const AzureActiveDirectoryAppClientId =
  process.env.REACT_APP_CLIENT_ID || "bfc95310-ed57-4fd3-9403-ad4c465d04ac";
const AzureTenantId =
  process.env.REACT_APP_TENANT_ID || "079f0f10-14a7-420a-9161-5233ef8aee2a";

// MSAL configuration
export const msalConfig = {
  auth: {
    clientId: AzureActiveDirectoryAppClientId,
    authority: `https://login.microsoftonline.com/common`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Scopes for authentication
// Get Dynamics 365 resource URL from environment
const dynamicsBaseUrl =
  process.env.REACT_APP_DYNAMICS_BASE_URL ||
  "https://shpdev01274a5a74e0a95c97devaos.cloudax.eu.dynamics.com";

// Login request - only basic Graph API scopes
export const loginRequest = {
  scopes: ["User.Read"],
};

// Dynamics 365 token request - use .default scope separately
export const dynamicsTokenRequest = {
  scopes: [`${dynamicsBaseUrl}/.default`],
};

export default msalConfig;
